import { render, staticRenderFns } from "./discountRollAdd.vue?vue&type=template&id=46720b47&scoped=true"
import script from "./discountRollAdd.vue?vue&type=script&lang=js"
export * from "./discountRollAdd.vue?vue&type=script&lang=js"
import style0 from "./discountRollAdd.vue?vue&type=style&index=0&id=46720b47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46720b47",
  null
  
)

export default component.exports